// frontend/src/components/ProfileBlockEditors/TextBlockEditor.js
import React from 'react';

const TextBlockEditor = ({ block, onChange }) => {
    const handleChange = (field, value) => {
        onChange({
            ...block,
            content: {
                ...block.content,
                [field]: value
            }
        });
    };

    return (
        <div className="flex flex-col gap-4">
            <div>
                <label className="block text-label-large text-surface-onVariant mb-1">
                    Titel
                </label>
                <input
                    type="text"
                    value={block.content?.title || ''}
                    onChange={(e) => handleChange('title', e.target.value)}
                    placeholder="z.B. Über mich"
                    className="md3-textfield-outlined w-full"
                />
            </div>

            <div>
                <label className="block text-label-large text-surface-onVariant mb-1">
                    Text
                </label>
                <textarea
                    value={block.content?.text || ''}
                    onChange={(e) => handleChange('text', e.target.value)}
                    placeholder="Schreibe hier deinen Text..."
                    rows={4}
                    className="md3-textfield-outlined w-full h-auto py-3 resize-y"
                />
            </div>
        </div>
    );
};

export default TextBlockEditor;
